// extracted by mini-css-extract-plugin
module.exports = {"Icon":"Icon--3KWlT","Button":"Button--3O-5o"};